import { IBatterySocCounts, IBatteryStates } from '../../../types/battery'
import { IGeneration } from '../../../types/generation'
import { IRevenue } from '../../../types/revenue'
import { modelApi } from '../../apiInstances'

export default {
  fetchGenerationData({
    id = '',
    startDate = '',
    endDate = '',
    range = '',
  } = {}): Promise<IGeneration> {
    return modelApi.post(
      '/gen/',
      { id, startDate, endDate, range },
      { convertResponseBodyToCamelCase: false },
    )
  },
  fetchSocCounts(id: string): Promise<IBatterySocCounts> {
    return modelApi.post('/result/soc_counts_percent_data', { id })
  },
  fetchBatteryStates({
    id = '',
    startDate = '',
    endDate = '',
    range = '',
  } = {}): Promise<IBatteryStates> {
    return modelApi.post(
      '/result/batterystates_data',
      { id, startDate, endDate, range },
      { convertResponseBodyToCamelCase: false },
    )
  },
  fetchRevenues({ id = '', startDate = '', endDate = '', range = '' } = {}): Promise<IRevenue> {
    return modelApi.post(
      '/result/revenue_data_data',
      { id, startDate, endDate, range },
      { convertResponseBodyToCamelCase: false },
    )
  },
}
